import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  MdOutlineSort,
  MdOutlineVerticalAlignBottom,
  MdOutlineVerticalAlignTop,
} from "react-icons/md";
import { useIntl } from "react-intl";

import { MenuAction } from "@nens/ranalib";
import { MoveDirection } from "@nens/shared-utils";

interface UseMoveActionsOptions {
  onMove: (direction: MoveDirection) => void;
  isFirst: boolean;
  isLast: boolean;
}

export function useMoveActions({ onMove, isFirst, isLast }: UseMoveActionsOptions): MenuAction {
  const intl = useIntl();

  const alreadyAtTop = isFirst
    ? intl.formatMessage({
        id: "publication.contextmenu.move.already_at_top",
        defaultMessage: "Already at the top",
      })
    : undefined;

  const alreadyAtBottom = isLast
    ? intl.formatMessage({
        id: "publication.contextmenu.move.already_at_bottom",
        defaultMessage: "Already at the bottom",
      })
    : undefined;

  return {
    label: intl.formatMessage({
      id: "publication.contextmenu.move",
      defaultMessage: "Move",
    }),
    icon: <MdOutlineSort />,
    subActions: [
      {
        label: intl.formatMessage({
          id: "publication.contextmenu.move_to_top",
          defaultMessage: "Move to top",
        }),
        icon: <MdOutlineVerticalAlignTop />,
        action: () => onMove("top"),
        disabledText: alreadyAtTop,
      },
      {
        label: intl.formatMessage({
          id: "publication.contextmenu.move_up",
          defaultMessage: "Move up",
        }),
        icon: <ChevronUpIcon />,
        action: () => onMove("up"),
        disabledText: alreadyAtTop,
      },
      {
        label: intl.formatMessage({
          id: "publication.contextmenu.move_down",
          defaultMessage: "Move down",
        }),
        icon: <ChevronDownIcon />,
        action: () => onMove("down"),
        disabledText: alreadyAtBottom,
      },
      {
        label: intl.formatMessage({
          id: "publication.contextmenu.move_to_bottom",
          defaultMessage: "Move to bottom",
        }),
        icon: <MdOutlineVerticalAlignBottom />,
        action: () => onMove("bottom"),
        disabledText: alreadyAtBottom,
      },
    ],
  };
}
